import { type RefObject, useEffect, useState } from 'react';
import type { StageSize } from './globe/camera';

/** Size of the hero stage and the podium's width/bottom inside it. */
export function useStageSize(wrapRef: RefObject<HTMLElement | null>, platformRef: RefObject<HTMLElement | null>): StageSize {
    const [size, setSize] = useState<StageSize>({ width: 0, height: 0, platformWidth: 0, platformBottom: 0 });

    useEffect(() => {
        const wrap = wrapRef.current;

        if (!wrap) {
            return;
        }

        const measure = () => {
            const rect = wrap.getBoundingClientRect();
            const platform = platformRef.current?.getBoundingClientRect();
            const next = {
                width: Math.round(rect.width),
                height: Math.round(rect.height),
                platformWidth: Math.round(platform?.width ?? rect.width),
                platformBottom: Math.round((platform?.bottom ?? rect.bottom) - rect.top),
            };

            setSize((previous) =>
                previous.width === next.width &&
                previous.height === next.height &&
                previous.platformWidth === next.platformWidth &&
                previous.platformBottom === next.platformBottom
                    ? previous
                    : next,
            );
        };
        const observer = new ResizeObserver(measure);
        observer.observe(wrap);

        if (platformRef.current) {
            observer.observe(platformRef.current);
        }

        measure();

        return () => observer.disconnect();
    }, [platformRef, wrapRef]);

    return size;
}
